import React, { useState, useEffect, useMemo, useRef } from 'react';
import ConfirmModal from './ConfirmModal';
import SettingsModal from './SettingsModal';
import DatePicker from './DatePicker';
import { ServerIcon } from '../utils/serverIcons';
import './ManagerManagement.css';
import './FormModal.css';
import './Vacations.css';

const ManagerManagement = () => {
  const [moderators, setModerators] = useState([]);
  const [servers, setServers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [userRoles, setUserRoles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: null
  });
  const [formData, setFormData] = useState({
    server: '',
    nickname: '',
    angrySpace: '',
    login: '',
    discordID: '',
  });
  const [serverSelectOpen, setServerSelectOpen] = useState(false);
  const serverSelectRef = useRef(null);

  // Состояние для выдачи выговора
  const [showReprimandModal, setShowReprimandModal] = useState(false);
  const [reprimandTarget, setReprimandTarget] = useState(null);
  const [reprimandFormData, setReprimandFormData] = useState({
    reason: '',
    issued_at: ''
  });
  const [isSubmittingReprimand, setIsSubmittingReprimand] = useState(false);
  
  // Состояние для общего выговора
  const [showCommonReprimandModal, setShowCommonReprimandModal] = useState(false);
  const [commonReprimandFormData, setCommonReprimandFormData] = useState({
    reason: '',
    issued_at: ''
  });
  const [isSubmittingCommonReprimand, setIsSubmittingCommonReprimand] = useState(false);
  
  // Состояние для выбора выговора менеджера
  const [showSelectReprimandModal, setShowSelectReprimandModal] = useState(false);
  const [moderatorReprimands, setModeratorReprimands] = useState([]);
  const [selectedReprimand, setSelectedReprimand] = useState(null);
  const [loadingReprimands, setLoadingReprimands] = useState(false);
  const [removeReprimandTarget, setRemoveReprimandTarget] = useState(null);
  
  // Состояние для модального окна выбора действия с выговорами
  const [showReprimandActionModal, setShowReprimandActionModal] = useState(false);
  const [reprimandActionTarget, setReprimandActionTarget] = useState(null);
  
  const [activeSearch, setActiveSearch] = useState('');
  const [deletedSearch, setDeletedSearch] = useState('');
  const [activePage, setActivePage] = useState(1);
  const [deletedPage, setDeletedPage] = useState(1);
  const itemsPerPage = 10;
  const [callHistory, setCallHistory] = useState([]);
  const [callHistoryLoading, setCallHistoryLoading] = useState(false);
  const [callHistorySearch, setCallHistorySearch] = useState('');
  const [callHistoryPage, setCallHistoryPage] = useState(1);
  const [callHistoryTotal, setCallHistoryTotal] = useState(0);
  const [callHistoryTotalPages, setCallHistoryTotalPages] = useState(1);
  const callHistoryPerPage = 20;

  // Логи снятых менеджеров (из БД) — свёрнутая панель снизу
  const [moderLogSectionExpanded, setModerLogSectionExpanded] = useState(false);
  const [moderLogData, setModerLogData] = useState([]);
  const [moderLogTotal, setModerLogTotal] = useState(0);
  const [moderLogTotalPages, setModerLogTotalPages] = useState(1);
  const [moderLogLoading, setModerLogLoading] = useState(false);
  const [moderLogSearch, setModerLogSearch] = useState('');
  const [moderLogPage, setModerLogPage] = useState(1);
  const moderLogPerPage = 20;
  const moderLogSectionRef = useRef(null);
  const moderLogFileInputRef = useRef(null);
  // Форма добавления/редактирования записи лога
  const [showModerLogForm, setShowModerLogForm] = useState(false);
  const [editingLogId, setEditingLogId] = useState(null);
  const [moderLogFormData, setModerLogFormData] = useState({
    nickname: '',
    discordId: '',
    period: '',
    reason: '',
    comment: '',
    restorationDate: null
  });
  const [moderLogFormSubmitting, setModerLogFormSubmitting] = useState(false);
  const [moderLogImporting, setModerLogImporting] = useState(false);
  const [deletedSectionExpanded, setDeletedSectionExpanded] = useState(false);
  const [callHistorySectionExpanded, setCallHistorySectionExpanded] = useState(false);

  // Заявки на смену данных (Telegram)
  const [dataChangeSectionExpanded, setDataChangeSectionExpanded] = useState(false);
  const [dataChangeItems, setDataChangeItems] = useState([]);
  const [dataChangeLoading, setDataChangeLoading] = useState(false);
  const [dataChangeStatusFilter, setDataChangeStatusFilter] = useState('pending');
  const [dataChangeRejectModal, setDataChangeRejectModal] = useState({ isOpen: false, requestId: null });
  const [dataChangeRejectionReason, setDataChangeRejectionReason] = useState('');
  const [dataChangePendingCount, setDataChangePendingCount] = useState(0);

  // Проверка прав для работы с удалёнными менеджерами
  const canManageDeleted = () => {
    const allowedRoles = ['Deputy Chief Manager', 'Chief Manager', 'admin'];
    return allowedRoles.some(role => userRoles.includes(role));
  };

  // Права на логах снятых менеджеров (раздельно)
  const canAddModerLog = () =>
    ['Senior Manager', 'Deputy Chief Manager', 'Chief Manager', 'admin'].some((r) => userRoles.includes(r));
  const canEditModerLog = () =>
    ['Deputy Chief Manager', 'Chief Manager', 'admin'].some((r) => userRoles.includes(r));
  const canDeleteModerLog = () =>
    ['Chief Manager', 'admin'].some((r) => userRoles.includes(r));
  const canImportModerLogs = () => userRoles.includes('admin');
  const canReviewDataChanges = () =>
    ['Deputy Chief Manager', 'Chief Manager', 'admin'].some((r) =>
      userRoles.includes(r)
    );

  useEffect(() => {
    fetchModerators();
    fetchUserRoles();
    fetchServers();
  }, []);

  useEffect(() => {
    const onOutside = (e) => {
      if (serverSelectRef.current && !serverSelectRef.current.contains(e.target)) {
        setServerSelectOpen(false);
      }
    };
    if (serverSelectOpen) {
      document.addEventListener('click', onOutside);
      return () => document.removeEventListener('click', onOutside);
    }
  }, [serverSelectOpen]);

  useEffect(() => {
    fetchCallHistory();
  }, [callHistoryPage, callHistorySearch]);

  // Прокрутка к блоку логов при открытии
  useEffect(() => {
    if (moderLogSectionExpanded && moderLogSectionRef.current) {
      moderLogSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [moderLogSectionExpanded]);

  const fetchModerLogs = async () => {
    try {
      setModerLogLoading(true);
      const token = localStorage.getItem('token');
      const params = new URLSearchParams({
        page: String(moderLogPage),
        limit: String(moderLogPerPage)
      });
      if (moderLogSearch.trim()) params.set('search', moderLogSearch.trim());
      const response = await fetch(`/api/moderator-logs?${params}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Не удалось загрузить логи');
      const data = await response.json();
      setModerLogData(data.items || []);
      setModerLogTotal(data.total ?? 0);
      setModerLogTotalPages(data.totalPages ?? 1);
    } catch (err) {
      console.error('Error loading moder logs:', err);
      setError(err.message || 'Не удалось загрузить логи снятых менеджеров');
    } finally {
      setModerLogLoading(false);
    }
  };

  useEffect(() => {
    if (moderLogSectionExpanded) fetchModerLogs();
  }, [moderLogSectionExpanded, moderLogPage, moderLogSearch]);

  const fetchDataChangeRequests = async () => {
    if (!canReviewDataChanges()) return;
    try {
      setDataChangeLoading(true);
      const token = localStorage.getItem('token');
      const response = await fetch(
        `/api/moderator-data-changes?status=${encodeURIComponent(dataChangeStatusFilter)}&limit=50`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.ok) {
        const data = await response.json();
        setDataChangeItems(data.items || []);
        if (dataChangeStatusFilter === 'pending') {
          setDataChangePendingCount(data.total ?? data.items?.length ?? 0);
        }
      }
    } catch (err) {
      console.error('Error fetching data change requests:', err);
    } finally {
      setDataChangeLoading(false);
    }
  };

  const fetchDataChangePendingCount = async () => {
    if (!canReviewDataChanges()) return;
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/moderator-data-changes?status=pending&limit=1', {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setDataChangePendingCount(data.total ?? 0);
      }
    } catch (err) {
      console.error('Error fetching data change pending count:', err);
    }
  };

  useEffect(() => {
    if (canReviewDataChanges()) fetchDataChangePendingCount();
  }, [userRoles]);

  useEffect(() => {
    if (dataChangeSectionExpanded && canReviewDataChanges()) {
      fetchDataChangeRequests();
    }
  }, [dataChangeSectionExpanded, dataChangeStatusFilter, userRoles]);

  const handleApproveDataChange = async (requestId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/moderator-data-changes/${requestId}/approve`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
      });
      if (response.ok) {
        await fetchDataChangeRequests();
        await fetchDataChangePendingCount();
        await fetchModerators();
        setSuccess('Заявка на смену данных одобрена');
      } else {
        const err = await response.json().catch(() => ({}));
        setError(err.error || 'Ошибка при одобрении заявки');
      }
    } catch (err) {
      console.error('Error approving data change:', err);
      setError('Ошибка при одобрении заявки');
    }
  };

  const handleRejectDataChange = async (requestId, reason) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/moderator-data-changes/${requestId}/reject`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ rejectionReason: reason })
      });
      if (response.ok) {
        await fetchDataChangeRequests();
        await fetchDataChangePendingCount();
        setDataChangeRejectModal({ isOpen: false, requestId: null });
        setDataChangeRejectionReason('');
        setSuccess('Заявка отклонена');
      } else {
        const err = await response.json().catch(() => ({}));
        setError(err.error || 'Ошибка при отклонении заявки');
      }
    } catch (err) {
      console.error('Error rejecting data change:', err);
      setError('Ошибка при отклонении заявки');
    }
  };


  const openModerLogForm = (log = null) => {
    if (log) {
      setEditingLogId(log.id);
      setModerLogFormData({
        nickname: log.nickname || '',
        discordId: log.discordId || '',
        period: log.period || '',
        reason: log.reason || '',
        comment: log.comment || '',
        restorationDate: log.restorationDate || null
      });
    } else {
      setEditingLogId(null);
      setModerLogFormData({ nickname: '', discordId: '', period: '', reason: '', comment: '', restorationDate: null });
    }
    setShowModerLogForm(true);
  };

  const closeModerLogForm = () => {
    setShowModerLogForm(false);
    setEditingLogId(null);
    setModerLogFormData({ nickname: '', discordId: '', period: '', reason: '', comment: '', restorationDate: null });
  };

  const handleModerLogFormSubmit = async (e) => {
    e.preventDefault();
    setModerLogFormSubmitting(true);
    try {
      const token = localStorage.getItem('token');
      const payload = { ...moderLogFormData };
      if (payload.restorationDate) payload.restorationDate = payload.restorationDate instanceof Date ? payload.restorationDate.toISOString() : payload.restorationDate;
      const body = JSON.stringify(payload);
      const url = editingLogId
        ? `/api/moderator-logs/${editingLogId}`
        : '/api/moderator-logs';
      const method = editingLogId ? 'PUT' : 'POST';
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body
      });
      if (!response.ok) {
        const errData = await response.json().catch(() => ({}));
        throw new Error(errData.error || 'Ошибка сохранения');
      }
      setSuccess(editingLogId ? 'Запись обновлена' : 'Запись добавлена');
      closeModerLogForm();
      fetchModerLogs();
    } catch (err) {
      setError(err.message);
    } finally {
      setModerLogFormSubmitting(false);
    }
  };

  const handleDeleteModerLog = (log) => {
    setConfirmModal({
      isOpen: true,
      title: 'Удалить запись из логов?',
      message: `Удалить запись: ${log.nickname || '—'} (${log.period || '—'})?`,
      onConfirm: async () => {
        setConfirmModal({ isOpen: false, title: '', message: '', onConfirm: null });
        try {
          const token = localStorage.getItem('token');
          const response = await fetch(`/api/moderator-logs/${log.id}`, {
            method: 'DELETE',
            headers: { Authorization: `Bearer ${token}` }
          });
          if (!response.ok) throw new Error('Не удалось удалить');
          setSuccess('Запись удалена');
          fetchModerLogs();
        } catch (err) {
          setError(err.message);
        }
      }
    });
  };

  const parseModerLogCSV = (text) => {
    const rows = [];
    let row = [];
    let cell = '';
    let inQuotes = false;
    for (let i = 0; i < text.length; i++) {
      const c = text[i];
      if (c === '"') inQuotes = !inQuotes;
      else if (!inQuotes && c === ',') {
        row.push(cell.trim());
        cell = '';
      } else if (!inQuotes && (c === '\n' || c === '\r')) {
        if (c === '\r' && text[i + 1] === '\n') i++;
        row.push(cell.trim());
        cell = '';
        if (row.some((x) => x)) rows.push(row);
        row = [];
      } else if (c !== '\r') cell += c;
    }
    if (cell || row.length) {
      row.push(cell.trim());
      if (row.some((x) => x)) rows.push(row);
    }
    return rows;
  };

  const parseCsvToLogRows = (text) => {
    const rows = parseModerLogCSV(text);
    if (rows.length === 0) return [];
    const headerLike = (r) => {
      const first = (r[0] || '').toLowerCase();
      return first.includes('никнейм') || (r[1] || '').toLowerCase().includes('discord');
    };
    let start = 0;
    if (rows.length >= 1 && headerLike(rows[0])) start = 1;
    else if (rows.length >= 2 && headerLike(rows[1])) start = 2;
    return rows.slice(start).map((r) => ({
      nickname: (r[0] || '').trim(),
      discordId: (r[1] || '').trim(),
      period: (r[2] || '').trim(),
      reason: (r[3] || '').trim(),
      comment: (r[4] || '').trim()
    }));
  };

  const doImportModerLogsRows = async (dataRows) => {
    if (!dataRows.length) {
      setError('В файле нет данных для импорта');
      return;
    }
    setModerLogImporting(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      const importRes = await fetch('/api/moderator-logs/import', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ rows: dataRows })
      });
      if (!importRes.ok) {
        const errData = await importRes.json().catch(() => ({}));
        throw new Error(errData.error || 'Ошибка импорта');
      }
      const result = await importRes.json();
      setSuccess(`Импортировано записей: ${result.imported || 0}`);
      fetchModerLogs();
    } catch (err) {
      setError(err.message || 'Ошибка импорта');
    } finally {
      setModerLogImporting(false);
    }
  };

  const handleModerLogFileSelect = (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setModerLogImporting(true);
    setError('');
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const text = reader.result || '';
        const dataRows = parseCsvToLogRows(text);
        doImportModerLogsRows(dataRows);
      } catch (err) {
        setError(err.message || 'Ошибка чтения файла');
        setModerLogImporting(false);
      }
    };
    reader.onerror = () => {
      setError('Не удалось прочитать файл');
      setModerLogImporting(false);
    };
    reader.readAsText(file, 'UTF-8');
  };

  const fetchCallHistory = async () => {
    try {
      setCallHistoryLoading(true);
      const token = localStorage.getItem('token');
      const params = new URLSearchParams({
        page: String(callHistoryPage),
        limit: String(callHistoryPerPage)
      });
      if (callHistorySearch.trim()) params.set('search', callHistorySearch.trim());
      const response = await fetch(`/api/junior-calls?${params}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setCallHistory(data.items || []);
        setCallHistoryTotal(data.total ?? 0);
        setCallHistoryTotalPages(data.totalPages ?? 1);
      }
    } catch (err) {
      console.error('Error fetching call history:', err);
    } finally {
      setCallHistoryLoading(false);
    }
  };

  const fetchUserRoles = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/auth/check-roles', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setUserRoles(data.roles || []);
      }
    } catch (err) {
      console.error('Error fetching user roles:', err);
    }
  };

  const fetchServers = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/servers', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setServers(data);
      }
    } catch (err) {
      console.error('Error fetching servers:', err);
    }
  };

  const fetchModerators = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await fetch(
        `/api/managers?includeDeleted=true`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (!response.ok) {
        throw new Error('Ошибка при загрузке менеджеров');
      }

      const data = await response.json();
      setModerators(data);
      setError('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Разделение на активных и удалённых
  const allActiveModerators = moderators.filter(m => !m.deleted_at);
  const allDeletedModerators = moderators.filter(m => m.deleted_at);

  // Фильтрация активных менеджеров
  const filteredActiveModerators = allActiveModerators.filter(moderator => {
    if (!activeSearch) return true;
    const search = activeSearch.toLowerCase();

    return (
      moderator.server?.toLowerCase().includes(search) ||
      moderator.nickname?.toLowerCase().includes(search) ||
      moderator.angry_space?.toLowerCase().includes(search) ||
      moderator.login?.toLowerCase().includes(search) ||
      moderator.discord_id?.toLowerCase().includes(search)
    );
  });

  // Фильтрация удалённых менеджеров
  const filteredDeletedModerators = allDeletedModerators.filter(moderator => {
    if (!deletedSearch) return true;
    const search = deletedSearch.toLowerCase();

    return (
      moderator.server?.toLowerCase().includes(search) ||
      moderator.nickname?.toLowerCase().includes(search) ||
      moderator.angry_space?.toLowerCase().includes(search) ||
      moderator.login?.toLowerCase().includes(search) ||
      moderator.discord_id?.toLowerCase().includes(search)
    );
  });

  // Пагинация для активных
  const activeTotalPages = Math.ceil(filteredActiveModerators.length / itemsPerPage);
  const activeStartIndex = (activePage - 1) * itemsPerPage;
  const activeModerators = filteredActiveModerators.slice(activeStartIndex, activeStartIndex + itemsPerPage);

  // Пагинация для удалённых
  const deletedTotalPages = Math.ceil(filteredDeletedModerators.length / itemsPerPage);
  const deletedStartIndex = (deletedPage - 1) * itemsPerPage;
  const deletedModerators = filteredDeletedModerators.slice(deletedStartIndex, deletedStartIndex + itemsPerPage);

  const serverIconMap = useMemo(() => {
    const m = {};
    servers.forEach((s) => {
      m[`RU${s.server_number}_${s.server_name}`] = s.icon_url || null;
    });
    return m;
  }, [servers]);

  // Сброс страницы при изменении поиска
  useEffect(() => {
    setActivePage(1);
  }, [activeSearch]);

  useEffect(() => {
    setDeletedPage(1);
  }, [deletedSearch]);

  const parseModeratorRoles = (moderator) => {
    if (!moderator?.roles) return [];
    if (Array.isArray(moderator.roles)) return moderator.roles;
    if (typeof moderator.roles === 'string') {
      try {
        return JSON.parse(moderator.roles);
      } catch (e) {
        return [];
      }
    }
    return [];
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const processedValue = name === 'discordID' ? value.trimEnd() : value;
    setFormData({
      ...formData,
      [name]: processedValue
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Находим выбранный сервер
    const selectedServer = servers.find(s => s.id.toString() === formData.server);
    if (!selectedServer) {
      setError('Выберите сервер из списка');
      return;
    }

    // Формируем строку сервера в формате RU{номер}_{название}
    const serverString = `RU${selectedServer.server_number}_${selectedServer.server_name}`;

    setIsSubmitting(true);

    try {
      const token = localStorage.getItem('token');
      const url = editingId
        ? `/api/managers/${editingId}`
        : '/api/managers';
      
      const method = editingId ? 'PUT' : 'POST';

      const rolesToSend = editingId
        ? parseModeratorRoles(moderators.find((m) => m.id === editingId))
        : [];

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          server: serverString,
          nickname: formData.nickname,
          angrySpace: formData.angrySpace ?? '',
          login: formData.login ?? '',
          discordID: formData.discordID,
          roles: rolesToSend
        })
      });

      const data = await response.json();

      if (!response.ok) {
        // Если менеджер был удалён, показываем специальное сообщение
        if (data.code === 'DELETED_EXISTS' || data.code === 'ACTIVE_EXISTS') {
          setError(data.error);
        } else {
          setError(data.error || 'Ошибка при сохранении');
        }
        setIsSubmitting(false);
        return;
      }

      // Закрываем форму и обновляем список сразу
      resetForm();
      fetchModerators();
      setSuccess(editingId ? 'Менеджер обновлён' : 'Менеджер добавлен');
    } catch (err) {
      setError(err.message);
      setIsSubmitting(false);
    }
  };

  const handleEdit = (moderator) => {
    setEditingId(moderator.id);
    // Парсим строку сервера формата RU{номер}_{название}
    const serverMatch = moderator.server.match(/^RU(\d+)_(.+)$/);
    let serverId = '';
    
    if (serverMatch && servers.length > 0) {
      const foundServer = servers.find(s => 
        s.server_number === serverMatch[1] && s.server_name === serverMatch[2]
      );
      serverId = foundServer ? foundServer.id.toString() : '';
    }
    
    setFormData({
      server: serverId,
      nickname: moderator.nickname,
      angrySpace: moderator.angry_space || '',
      login: moderator.login || '',
      discordID: moderator.discord_id,
    });
    setShowForm(true);
  };

  const formatDateForLog = (dateStr) => {
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const handleDelete = (moderator) => {
    const id = moderator.id;
    setConfirmModal({
      isOpen: true,
      title: 'Подтвердите действие',
      message: 'Вы уверены, что хотите удалить этого менеджера?',
      onConfirm: async () => {
        try {
          const token = localStorage.getItem('token');
          const response = await fetch(`/api/managers/${id}`, {
            method: 'DELETE',
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });

          const data = await response.json();

          if (!response.ok) {
            throw new Error(data.error || 'Ошибка при удалении');
          }

          setSuccess('Менеджер удалён');
          setConfirmModal({ isOpen: false, title: '', message: '', onConfirm: null });
          fetchModerators();

          // Второй вопрос: внести в лог удалённых?
          const deletedModerator = {
            nickname: moderator.nickname || '',
            discord_id: moderator.discord_id || '',
            created_at: moderator.created_at,
            restored_at: moderator.restored_at
          };
          const dateForPeriod = deletedModerator.restored_at || deletedModerator.created_at;
          setConfirmModal({
            isOpen: true,
            title: 'Добавить в лог удалённых?',
            message: 'Хотите сразу внести менеджера в лог удалённых?',
            onConfirm: () => {
              setConfirmModal({ isOpen: false, title: '', message: '', onConfirm: null });
              const period = `${formatDateForLog(dateForPeriod)} - ${formatDateForLog(new Date())}`;
              setModerLogFormData({
                nickname: deletedModerator.nickname,
                discordId: deletedModerator.discord_id,
                period,
                reason: '',
                comment: '',
                restorationDate: dateForPeriod
              });
              setEditingLogId(null);
              setModerLogSectionExpanded(true);
              setShowModerLogForm(true);
            }
          });
        } catch (err) {
          setError(err.message);
          setConfirmModal({ isOpen: false, title: '', message: '', onConfirm: null });
        }
      }
    });
  };

  const handleRestore = async (id) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/managers/${id}/restore`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Ошибка при восстановлении');
      }

      setSuccess('Менеджер восстановлен');
      fetchModerators();
    } catch (err) {
      setError(err.message);
    }
  };

  const resetForm = () => {
    setEditingId(null);
    setShowForm(false);
    setIsSubmitting(false);
    setFormData({
      server: '',
      nickname: '',
      angrySpace: '',
      login: '',
      discordID: '',
    });
  };

  // Функция для закрытия всех модальных окон
  const closeAllModals = () => {
    setShowForm(false);
    setShowReprimandModal(false);
    setShowCommonReprimandModal(false);
    setShowSelectReprimandModal(false);
    setShowReprimandActionModal(false);
    setReprimandTarget(null);
    setReprimandActionTarget(null);
    setSelectedReprimand(null);
    setModeratorReprimands([]);
    setRemoveReprimandTarget(null);
    setReprimandFormData({ reason: '', issued_at: '' });
    setCommonReprimandFormData({ reason: '', issued_at: '' });
    setError('');
    setSuccess('');
  };

  const handleAddClick = () => {
    closeAllModals();
    setTimeout(() => {
      resetForm();
      setShowForm(true);
    }, 0);
  };

  // Функции для работы с выговорами
  const formatDateForServer = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleReprimandClick = (moderator) => {
    closeAllModals();
    setTimeout(() => {
      setReprimandActionTarget(moderator);
      setShowReprimandActionModal(true);
    }, 0);
  };

  const handleIssueReprimand = (moderator) => {
    closeAllModals();
    setTimeout(() => {
      const today = new Date();
      setReprimandTarget(moderator);
      setReprimandFormData({
        reason: '',
        issued_at: formatDateForServer(today)
      });
      setShowReprimandModal(true);
    }, 0);
  };

  const handleSubmitReprimand = async () => {
    if (!reprimandFormData.reason.trim()) {
      setError('Введите причину выговора');
      return;
    }

    setIsSubmittingReprimand(true);
    setError('');
    setSuccess('');

    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/reprimands', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          nickname: reprimandTarget.nickname,
          reason: reprimandFormData.reason,
          issued_at: reprimandFormData.issued_at
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Ошибка при выдаче выговора');
      }

      setSuccess('Выговор успешно выдан');
      closeAllModals();
      setReprimandFormData({ reason: '', issued_at: '' });
      fetchModerators(); // Обновляем список для обновления счётчика выговоров
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmittingReprimand(false);
    }
  };

  // Функции для работы с общим выговором
  const handleIssueCommonReprimand = () => {
    closeAllModals();
    setTimeout(() => {
      const today = new Date();
      setCommonReprimandFormData({
        reason: '',
        issued_at: formatDateForServer(today)
      });
      setShowCommonReprimandModal(true);
    }, 0);
  };

  const handleSubmitCommonReprimand = async () => {
    if (!commonReprimandFormData.reason.trim()) {
      setError('Введите причину общего выговора');
      return;
    }

    setIsSubmittingCommonReprimand(true);
    setError('');
    setSuccess('');

    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/reprimands/common', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          reason: commonReprimandFormData.reason,
          issued_at: commonReprimandFormData.issued_at
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Ошибка при выдаче общего выговора');
      }

      setSuccess(`Общий выговор успешно выдан ${data.count} менеджерам`);
      closeAllModals();
      setCommonReprimandFormData({ reason: '', issued_at: '' });
      fetchModerators();
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmittingCommonReprimand(false);
    }
  };


  // Функция для снятия выговора конкретного менеджера
  const handleRemoveReprimand = async (moderator) => {
    if (!moderator.reprimands_count || moderator.reprimands_count === 0) {
      setError('У менеджера нет активных выговоров');
      return;
    }

    closeAllModals();
    setRemoveReprimandTarget(moderator);
    setLoadingReprimands(true);
    setSelectedReprimand(null);
    
    try {
      const token = localStorage.getItem('token');
      
      // Получаем список активных выговоров менеджера
      const reprimandsResponse = await fetch(`/api/reprimands/moderator/${encodeURIComponent(moderator.nickname)}?showExpired=false`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!reprimandsResponse.ok) {
        throw new Error('Ошибка при получении списка выговоров');
      }
      
      const reprimands = await reprimandsResponse.json();
      
      if (reprimands.length === 0) {
        setError('У менеджера нет активных выговоров');
        setLoadingReprimands(false);
        return;
      }
      
      setModeratorReprimands(reprimands);
      setTimeout(() => {
        setShowSelectReprimandModal(true);
      }, 0);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoadingReprimands(false);
    }
  };

  const handleConfirmRemoveReprimand = async () => {
    if (!selectedReprimand) {
      setError('Выберите выговор для снятия');
      return;
    }

    setConfirmModal({
      isOpen: true,
      title: 'Снять выговор досрочно',
      message: `Вы уверены, что хотите снять выговор от ${new Date(selectedReprimand.issued_at).toLocaleDateString('ru-RU')} с причиной "${selectedReprimand.reason}"?`,
      onConfirm: async () => {
        // Сначала закрываем модальное окно подтверждения
        setConfirmModal({ isOpen: false, title: '', message: '', onConfirm: null });
        
        // Закрываем модальное окно выбора выговора
        closeAllModals();
        
        // Небольшая задержка для закрытия модальных окон
        await new Promise(resolve => setTimeout(resolve, 150));
        
        try {
          const token = localStorage.getItem('token');
          
          const removeResponse = await fetch(`/api/reprimands/${selectedReprimand.id}/remove`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          
          if (!removeResponse.ok) {
            const error = await removeResponse.json();
            throw new Error(error.error || 'Ошибка при снятии выговора');
          }
          
          setSuccess(`Выговор снят у менеджера ${removeReprimandTarget.nickname}`);
          fetchModerators();
        } catch (err) {
          setError(err.message);
        }
      }
    });
  };

  return (
    <div className="moderator-management">
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        onClose={() => setConfirmModal({ isOpen: false, title: '', message: '', onConfirm: null })}
        onConfirm={confirmModal.onConfirm}
        title={confirmModal.title}
        message={confirmModal.message}
      />

      {dataChangeRejectModal.isOpen && (
        <div
          className="vacations-reject-modal-overlay"
          onClick={() => {
            setDataChangeRejectModal({ isOpen: false, requestId: null });
            setDataChangeRejectionReason('');
          }}
        >
          <div className="vacations-reject-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Причина отклонения заявки</h3>
            <textarea
              className="vacations-reject-reason-input"
              value={dataChangeRejectionReason}
              onChange={(e) => setDataChangeRejectionReason(e.target.value)}
              placeholder="Укажите причину отклонения (минимум 5 символов)..."
              rows={4}
            />
            <div className="vacations-reject-modal-actions">
              <button
                type="button"
                className="vacations-reject-cancel"
                onClick={() => {
                  setDataChangeRejectModal({ isOpen: false, requestId: null });
                  setDataChangeRejectionReason('');
                }}
              >
                Отмена
              </button>
              <button
                type="button"
                className="vacations-reject-confirm"
                disabled={dataChangeRejectionReason.trim().length < 5}
                onClick={() => {
                  if (dataChangeRejectionReason.trim().length >= 5) {
                    handleRejectDataChange(dataChangeRejectModal.requestId, dataChangeRejectionReason.trim());
                  }
                }}
              >
                Отклонить
              </button>
            </div>
          </div>
        </div>
      )}

      {error && (
        <div className="alert alert-error">
          {error}
        </div>
      )}

      {success && (
        <div className="alert alert-success">
          {success}
        </div>
      )}

      {/* Модальное окно: добавление/редактирование записи лога */}
      {showModerLogForm && (
        <div className="form-modal-overlay" onClick={closeModerLogForm}>
          <div className="form-modal moder-log-form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="form-modal-header">
              <h3>{editingLogId ? 'Редактировать запись' : 'Добавить запись в логи'}</h3>
              <button type="button" className="btn-close-form" onClick={closeModerLogForm} title="Закрыть">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
            <form onSubmit={handleModerLogFormSubmit} className="form-modal-body">
              <div className="form-grid">
                <div className="form-group">
                  <label>Никнейм менеджера</label>
                  <input
                    type="text"
                    value={moderLogFormData.nickname}
                    onChange={(e) => setModerLogFormData((prev) => ({ ...prev, nickname: e.target.value }))}
                    placeholder="Никнейм"
                  />
                </div>
                <div className="form-group">
                  <label>Discord ID</label>
                  <input
                    type="text"
                    value={moderLogFormData.discordId}
                    onChange={(e) => setModerLogFormData((prev) => ({ ...prev, discordId: e.target.value }))}
                    placeholder="<@!123...> или ID"
                  />
                </div>
                <div className="form-group form-group-full">
                  <label>Когда встал — когда ушёл</label>
                  <input
                    type="text"
                    value={moderLogFormData.period}
                    onChange={(e) => setModerLogFormData((prev) => ({ ...prev, period: e.target.value }))}
                    placeholder="23.07.2022 - 17.11.2022"
                  />
                </div>
                <div className="form-group">
                  <label>Причина</label>
                  <input
                    type="text"
                    value={moderLogFormData.reason}
                    onChange={(e) => setModerLogFormData((prev) => ({ ...prev, reason: e.target.value }))}
                    placeholder="ПСЖ, Инактив, leave in adm..."
                  />
                </div>
                <div className="form-group form-group-full">
                  <label>Комментарий</label>
                  <textarea
                    value={moderLogFormData.comment}
                    onChange={(e) => setModerLogFormData((prev) => ({ ...prev, comment: e.target.value }))}
                    placeholder="Комментарий"
                    rows={3}
                  />
                </div>
              </div>
              <div className="form-actions">
                <button type="submit" className="btn btn-primary" disabled={moderLogFormSubmitting}>
                  {moderLogFormSubmitting ? 'Сохранение...' : (editingLogId ? 'Сохранить' : 'Добавить')}
                </button>
                <button type="button" className="btn btn-secondary" onClick={closeModerLogForm} disabled={moderLogFormSubmitting}>
                  Отмена
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Модальное окно формы */}
      {showForm && (
        <div className="form-modal-overlay" onClick={() => { closeAllModals(); resetForm(); }}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="form-modal-header">
              <h3>{editingId ? 'Редактировать менеджера' : 'Добавить менеджера'}</h3>
              <button type="button" className="btn-close-form" onClick={() => { closeAllModals(); resetForm(); }} title="Закрыть">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            <form onSubmit={handleSubmit} className="form-modal-body">
              <div className="form-grid">
                <div className="form-group server-select-wrap" ref={serverSelectRef}>
                  <label htmlFor="server">Сервер *</label>
                  <div
                    className={`server-select-custom ${serverSelectOpen ? 'open' : ''} ${!formData.server ? 'placeholder' : ''}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (servers.length > 0) setServerSelectOpen((v) => !v);
                    }}
                    role="combobox"
                    aria-expanded={serverSelectOpen}
                    aria-haspopup="listbox"
                    id="server"
                  >
                    <span className="server-select-value">
                      {formData.server ? (() => {
                        const s = servers.find((sv) => String(sv.id) === String(formData.server));
                        if (s) {
                          return (
                            <>
                              <ServerIcon server={s} className="server-select-icon" size={20} />
                              <span className="server-select-value-text">RU{s.server_number}_{s.server_name}</span>
                            </>
                          );
                        }
                        return <span className="server-select-value-text">Сервер выбран</span>;
                      })() : (
                        <span className="server-select-placeholder">Выберите сервер</span>
                      )}
                    </span>
                    <span className="server-select-arrow">▾</span>
                  </div>
                  {serverSelectOpen && servers.length > 0 && (
                    <div className="server-select-dropdown" role="listbox">
                      {servers.map((server) => (
                        <div
                          key={server.id}
                          className={`server-select-option ${String(formData.server) === String(server.id) ? 'selected' : ''}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleInputChange({ target: { name: 'server', value: String(server.id) } });
                            setServerSelectOpen(false);
                          }}
                          role="option"
                        >
                          <ServerIcon server={server} className="server-select-option-icon" size={20} />
                          <span className="server-select-option-text">RU{server.server_number}_{server.server_name}</span>
                          {String(formData.server) === String(server.id) && <span className="server-select-option-check">✓</span>}
                        </div>
                      ))}
                    </div>
                  )}
                  {servers.length === 0 && (
                    <small className="form-hint" style={{ color: 'var(--error-color)' }}>
                      Нет доступных серверов. Добавьте серверы в разделе "Настройки"
                    </small>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="nickname">Никнейм *</label>
                  <input
                    type="text"
                    id="nickname"
                    name="nickname"
                    value={formData.nickname}
                    onChange={handleInputChange}
                    required
                    placeholder="Введите никнейм"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="angrySpace">Angry Space</label>
                  <input
                    type="text"
                    id="angrySpace"
                    name="angrySpace"
                    value={formData.angrySpace}
                    onChange={handleInputChange}
                    placeholder="Введите Angry Space"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="login">Логин</label>
                  <input
                    type="text"
                    id="login"
                    name="login"
                    value={formData.login}
                    onChange={handleInputChange}
                    placeholder="Введите логин"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="discordID">Discord ID *</label>
                  <input
                    type="text"
                    id="discordID"
                    name="discordID"
                    value={formData.discordID}
                    onChange={handleInputChange}
                    required
                    placeholder="Введите Discord ID"
                  />
                </div>
              </div>

              <div className="form-actions">
                <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                  {isSubmitting ? (editingId ? 'Сохранение...' : 'Добавление...') : (editingId ? 'Сохранить изменения' : 'Добавить менеджера')}
                </button>
                <button type="button" className="btn btn-secondary" onClick={resetForm} disabled={isSubmitting}>
                  Отмена
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Модальное окно для выдачи выговора */}
      {showReprimandModal && reprimandTarget && (
        <div className="form-modal-overlay" onClick={closeAllModals}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="form-modal-header">
              <h3>Выдать выговор</h3>
              <button type="button" className="btn-close-form" onClick={closeAllModals} title="Закрыть">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            <div className="form-modal-body">
              <div className="form-group">
                <label>Менеджер</label>
                <input
                  type="text"
                  value={reprimandTarget.nickname}
                  disabled
                  className="form-input-disabled"
                />
              </div>

              <div className="form-group">
                <label htmlFor="reprimand-reason">Причина выговора *</label>
                <textarea
                  id="reprimand-reason"
                  value={reprimandFormData.reason}
                  onChange={(e) => setReprimandFormData({ ...reprimandFormData, reason: e.target.value })}
                  required
                  placeholder="Опишите причину выговора"
                  rows={4}
                />
              </div>

              <div className="form-group">
                <label htmlFor="reprimand-date">Дата выдачи</label>
                <div className="date-picker-wrapper">
                  <DatePicker
                    selectedDate={reprimandFormData.issued_at ? (() => {
                      const dateStr = reprimandFormData.issued_at;
                      try {
                        if (typeof dateStr === 'string' && dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
                          const [year, month, day] = dateStr.split('-').map(Number);
                          const date = new Date(year, month - 1, day);
                          if (!isNaN(date.getTime())) {
                            return date;
                          }
                        }
                        const date = new Date(dateStr);
                        if (!isNaN(date.getTime())) {
                          return date;
                        }
                      } catch (e) {
                        console.error('Error parsing date:', e, dateStr);
                      }
                      return new Date();
                    })() : new Date()}
                    onDateChange={(date) => {
                      if (date instanceof Date && !isNaN(date.getTime())) {
                        const dateStr = formatDateForServer(date);
                        setReprimandFormData(prev => ({ ...prev, issued_at: dateStr }));
                      }
                    }}
                  />
                </div>
                <small className="form-hint">Дата снятия автоматически установится через 14 дней</small>
              </div>

              <div className="form-actions">
                <button 
                  type="button" 
                  className="btn btn-primary" 
                  onClick={handleSubmitReprimand}
                  disabled={isSubmittingReprimand}
                >
                  {isSubmittingReprimand ? 'Выдача...' : 'Выдать выговор'}
                </button>
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={closeAllModals}
                  disabled={isSubmittingReprimand}
                >
                  Отмена
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Модальное окно для общего выговора */}
      {showCommonReprimandModal && (
        <div className="form-modal-overlay" onClick={closeAllModals}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="form-modal-header">
              <h3>Выдать общий выговор</h3>
              <button type="button" className="btn-close-form" onClick={closeAllModals} title="Закрыть">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            <div className="form-modal-body">
              <div className="form-group">
                <label htmlFor="common-reprimand-reason">Причина общего выговора *</label>
                <textarea
                  id="common-reprimand-reason"
                  value={commonReprimandFormData.reason}
                  onChange={(e) => setCommonReprimandFormData({ ...commonReprimandFormData, reason: e.target.value })}
                  required
                  placeholder="Опишите причину общего выговора (будет выдан всем активным менеджерам)"
                  rows={4}
                />
                <small className="form-hint">Выговор будет автоматически выдан всем активным менеджерам</small>
              </div>

              <div className="form-group">
                <label htmlFor="common-reprimand-date">Дата выдачи</label>
                <div className="date-picker-wrapper">
                  <DatePicker
                    selectedDate={commonReprimandFormData.issued_at ? (() => {
                      const dateStr = commonReprimandFormData.issued_at;
                      try {
                        if (typeof dateStr === 'string' && dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
                          const [year, month, day] = dateStr.split('-').map(Number);
                          const date = new Date(year, month - 1, day);
                          if (!isNaN(date.getTime())) {
                            return date;
                          }
                        }
                        const date = new Date(dateStr);
                        if (!isNaN(date.getTime())) {
                          return date;
                        }
                      } catch (e) {
                        console.error('Error parsing date:', e, dateStr);
                      }
                      return new Date();
                    })() : new Date()}
                    onDateChange={(date) => {
                      if (date instanceof Date && !isNaN(date.getTime())) {
                        const dateStr = formatDateForServer(date);
                        setCommonReprimandFormData(prev => ({ ...prev, issued_at: dateStr }));
                      }
                    }}
                  />
                </div>
                <small className="form-hint">Дата снятия автоматически установится через 14 дней</small>
              </div>

              <div className="form-actions">
                <button 
                  type="button" 
                  className="btn btn-primary" 
                  onClick={handleSubmitCommonReprimand}
                  disabled={isSubmittingCommonReprimand}
                >
                  {isSubmittingCommonReprimand ? 'Выдача...' : 'Выдать общий выговор'}
                </button>
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={closeAllModals}
                  disabled={isSubmittingCommonReprimand}
                >
                  Отмена
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Модальное окно для выбора действия с выговорами */}
      {showReprimandActionModal && reprimandActionTarget && (
        <div className="form-modal-overlay" onClick={closeAllModals}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="form-modal-header">
              <h3>Управление выговорами</h3>
              <button type="button" className="btn-close-form" onClick={closeAllModals} title="Закрыть">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            <div className="form-modal-body">
              <div className="form-group">
                <label>Менеджер</label>
                <input
                  type="text"
                  value={reprimandActionTarget.nickname}
                  disabled
                  className="form-input-disabled"
                />
              </div>
              
              <div className="form-group">
                <label>Выберите действие</label>
                <div className="reprimand-action-buttons">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      closeAllModals();
                      setTimeout(() => {
                        handleIssueReprimand(reprimandActionTarget);
                      }, 0);
                    }}
                  >
                    Выдать выговор
                  </button>
                  {reprimandActionTarget.reprimands_count > 0 && (
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        closeAllModals();
                        setTimeout(() => {
                          handleRemoveReprimand(reprimandActionTarget);
                        }, 0);
                      }}
                    >
                      Снять выговор
                    </button>
                  )}
                </div>
              </div>

              <div className="form-actions">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={closeAllModals}
                >
                  Отмена
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Модальное окно для выбора выговора менеджера */}
      {showSelectReprimandModal && removeReprimandTarget && (
        <div className="form-modal-overlay" onClick={closeAllModals}>
          <div className="form-modal" onClick={(e) => e.stopPropagation()}>
            <div className="form-modal-header">
              <h3>Выберите выговор для снятия</h3>
              <button type="button" className="btn-close-form" onClick={closeAllModals} title="Закрыть">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>
            <div className="form-modal-body">
              <div className="form-group">
                <label>Менеджер: <strong>{removeReprimandTarget.nickname}</strong></label>
              </div>
              
              {loadingReprimands ? (
                <div className="loading">Загрузка выговоров...</div>
              ) : moderatorReprimands.length === 0 ? (
                <div className="empty-state">Нет активных выговоров</div>
              ) : (
                <div className="form-group">
                  <label>Выберите выговор для снятия *</label>
                  <div className="reprimands-select-list">
                    {moderatorReprimands.map((reprimand) => (
                      <div
                        key={reprimand.id}
                        className={`reprimand-select-item ${selectedReprimand?.id === reprimand.id ? 'selected' : ''}`}
                        onClick={() => setSelectedReprimand(reprimand)}
                      >
                        <div className="reprimand-select-header">
                          <input
                            type="radio"
                            name="selectedReprimand"
                            checked={selectedReprimand?.id === reprimand.id}
                            onChange={() => setSelectedReprimand(reprimand)}
                          />
                          <div className="reprimand-select-info">
                            <div className="reprimand-select-date">
                              {new Date(reprimand.issued_at).toLocaleDateString('ru-RU', {
                                day: 'numeric',
                                month: 'long',
                                year: 'numeric'
                              })}
                            </div>
                            <div className="reprimand-select-reason">{reprimand.reason}</div>
                            {reprimand.is_common && (
                              <span className="reprimand-common-badge">Общий выговор</span>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="form-actions">
                <button 
                  type="button" 
                  className="btn btn-primary" 
                  onClick={handleConfirmRemoveReprimand}
                  disabled={!selectedReprimand || isSubmittingReprimand}
                >
                  Снять выговор
                </button>
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={closeAllModals}
                >
                  Отмена
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* Списки менеджеров */}
      <div className="moderators-lists">
        {/* Активные менеджеры */}
        <div className="moderator-list-card">
          <div className="card-header active-moderators-header">
            <h3>Активные менеджеры ({filteredActiveModerators.length})</h3>
            <div className="active-moderators-header-actions">
              <button className="btn btn-add-moderator" onClick={handleAddClick} type="button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="12" y1="5" x2="12" y2="19"></line>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
                <span>Добавить менеджера</span>
              </button>
              <button className="btn btn-common-reprimand" onClick={handleIssueCommonReprimand} type="button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="12" y1="5" x2="12" y2="19"></line>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
                <span>Выдать общий выговор</span>
              </button>
              <input
                type="text"
                className="search-input"
                placeholder="Поиск..."
                value={activeSearch}
                onChange={(e) => setActiveSearch(e.target.value)}
              />
            </div>
          </div>
          
          {loading ? (
            <div className="loading">Загрузка...</div>
          ) : filteredActiveModerators.length === 0 ? (
            <div className="empty-state">
              {activeSearch ? 'Менеджеры не найдены по запросу' : 'Активные менеджеры не найдены'}
            </div>
          ) : (
            <div className="moderator-table-container">
              <table className="moderator-table">
                <thead>
                  <tr>
                    <th>Сервер</th>
                    <th>Никнейм</th>
                    <th>Angry Space</th>
                    <th>Логин</th>
                    <th>Discord ID</th>
                    <th>Выговора</th>
                    <th>Дата создания карточки</th>
                    <th>Дата восстановления</th>
                    <th className="actions-column">Действия</th>
                  </tr>
                </thead>
                <tbody>
                  {activeModerators.map((moderator) => (
                    <tr key={moderator.id}>
                      <td className="moderator-server-cell">
                        <div className="moderator-server-cell-inner">
                          <ServerIcon iconUrl={serverIconMap[moderator.server]} size={20} className="moderator-server-icon" />
                          <span className="moderator-server-name">{moderator.server}</span>
                        </div>
                      </td>
                      <td>{moderator.nickname}</td>
                      <td>{moderator.angry_space || '—'}</td>
                      <td>{moderator.login || '—'}</td>
                      <td>{moderator.discord_id}</td>
                      <td>
                        <span className={moderator.reprimands_count > 0 ? 'reprimands-count active' : 'reprimands-count'}>
                          {moderator.reprimands_count || 0}
                        </span>
                      </td>
                      <td>
                        {new Date(moderator.created_at).toLocaleString('ru-RU', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </td>
                      <td>
                        {moderator.restored_at
                          ? new Date(moderator.restored_at).toLocaleString('ru-RU', {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit'
                            })
                          : '—'}
                      </td>
                      <td className="actions-column">
                        <div className="action-buttons">
                          <button
                            className="btn-action btn-reprimand"
                            onClick={() => handleReprimandClick(moderator)}
                            title="Управление выговорами"
                          >
                            Выговора
                          </button>
                          <button
                            className="btn-action btn-edit"
                            onClick={() => handleEdit(moderator)}
                            title="Изменить"
                          >
                            Изменить
                          </button>
                          <button
                            className="btn-action btn-delete"
                            onClick={() => handleDelete(moderator)}
                            title="Удалить"
                          >
                            Удалить
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          
          {/* Пагинация для активных */}
          {!loading && filteredActiveModerators.length > 0 && activeTotalPages > 1 && (
            <div className="pagination">
              <button
                className="pagination-btn"
                onClick={() => setActivePage(prev => Math.max(1, prev - 1))}
                disabled={activePage === 1}
              >
                Назад
              </button>
              <span className="pagination-info">
                Страница{' '}
                <input
                  type="number"
                  className="pagination-input"
                  min={1}
                  max={activeTotalPages}
                  value={activePage}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (v === '') return;
                    const n = parseInt(v, 10);
                    if (!isNaN(n)) setActivePage(Math.max(1, Math.min(activeTotalPages, n)));
                  }}
                  aria-label="Номер страницы"
                />
                {' '}из {activeTotalPages}
              </span>
              <button
                className="pagination-btn"
                onClick={() => setActivePage(prev => Math.min(activeTotalPages, prev + 1))}
                disabled={activePage === activeTotalPages}
              >
                Вперёд
              </button>
            </div>
          )}
        </div>

        {/* Удалённые менеджеры (свёрнуто по умолчанию) */}
        <div className={`moderator-list-card moderator-list-deleted collapsible-card ${deletedSectionExpanded ? 'expanded' : ''}`}>
          <div
            className="card-header collapsible-header"
            onClick={() => setDeletedSectionExpanded(v => !v)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setDeletedSectionExpanded(v => !v); } }}
          >
            <h3>
              <span className="collapsible-chevron" aria-hidden>{deletedSectionExpanded ? '▼' : '▶'}</span>
              Удалённые менеджеры ({filteredDeletedModerators.length})
            </h3>
            {deletedSectionExpanded && (
              <div className="search-container" onClick={(e) => e.stopPropagation()}>
                <input
                  type="text"
                  className="search-input"
                  placeholder="Поиск..."
                  value={deletedSearch}
                  onChange={(e) => setDeletedSearch(e.target.value)}
                />
              </div>
            )}
          </div>

          {deletedSectionExpanded && (
          <>
          {loading ? (
            <div className="loading">Загрузка...</div>
          ) : filteredDeletedModerators.length === 0 ? (
            <div className="empty-state">
              {deletedSearch ? 'Менеджеры не найдены по запросу' : 'Удалённые менеджеры не найдены'}
            </div>
          ) : (
            <div className="moderator-table-container">
              <table className="moderator-table">
                <thead>
                  <tr>
                    <th>Сервер</th>
                    <th>Никнейм</th>
                    <th>Angry Space</th>
                    <th>Логин</th>
                    <th>Discord ID</th>
                    <th>Выговора</th>
                    <th>Дата создания карточки</th>
                    <th>Дата восстановления</th>
                    <th>Дата удаления</th>
                    <th className="actions-column">Действия</th>
                  </tr>
                </thead>
                <tbody>
                  {deletedModerators.map((moderator) => (
                    <tr key={moderator.id} className="deleted">
                      <td className="moderator-server-cell">
                        <div className="moderator-server-cell-inner">
                          <ServerIcon iconUrl={serverIconMap[moderator.server]} size={20} className="moderator-server-icon" />
                          <span className="moderator-server-name">{moderator.server}</span>
                        </div>
                      </td>
                      <td>{moderator.nickname}</td>
                      <td>{moderator.angry_space || '—'}</td>
                      <td>{moderator.login || '—'}</td>
                      <td>{moderator.discord_id}</td>
                      <td>
                        <span className={moderator.reprimands_count > 0 ? 'reprimands-count active' : 'reprimands-count'}>
                          {moderator.reprimands_count || 0}
                        </span>
                      </td>
                      <td>
                        {new Date(moderator.created_at).toLocaleString('ru-RU', {
                          year: 'numeric',
                          month: '2-digit',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit'
                        })}
                      </td>
                      <td>
                        {moderator.restored_at
                          ? new Date(moderator.restored_at).toLocaleString('ru-RU', {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit'
                            })
                          : '—'}
                      </td>
                      <td>
                        {moderator.deleted_at
                          ? new Date(moderator.deleted_at).toLocaleString('ru-RU', {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit'
                            })
                          : '-'}
                      </td>
                      <td className="actions-column">
                        <div className="action-buttons">
                          {canManageDeleted() ? (
                            <>
                              <button
                                className="btn-action btn-restore"
                                onClick={() => handleRestore(moderator.id)}
                                title="Восстановить"
                              >
                                Восстановить
                              </button>
                              <button
                                className="btn-action btn-edit"
                                onClick={() => handleEdit(moderator)}
                                title="Изменить"
                              >
                                Изменить
                              </button>
                            </>
                          ) : (
                            <span className="no-permission-text">Нет прав доступа</span>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          
          {/* Пагинация для удалённых */}
          {!loading && filteredDeletedModerators.length > 0 && deletedTotalPages > 1 && (
            <div className="pagination">
              <button
                className="pagination-btn"
                onClick={() => setDeletedPage(prev => Math.max(1, prev - 1))}
                disabled={deletedPage === 1}
              >
                Назад
              </button>
              <span className="pagination-info">
                Страница{' '}
                <input
                  type="number"
                  className="pagination-input"
                  min={1}
                  max={deletedTotalPages}
                  value={deletedPage}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (v === '') return;
                    const n = parseInt(v, 10);
                    if (!isNaN(n)) setDeletedPage(Math.max(1, Math.min(deletedTotalPages, n)));
                  }}
                  aria-label="Номер страницы"
                />
                {' '}из {deletedTotalPages}
              </span>
              <button
                className="pagination-btn"
                onClick={() => setDeletedPage(prev => Math.min(deletedTotalPages, prev + 1))}
                disabled={deletedPage === deletedTotalPages}
              >
                Вперёд
              </button>
            </div>
          )}
          </>
          )}
        </div>

        {/* История обзвонов Junior (свёрнуто по умолчанию) */}
        <div className={`moderator-list-card moderator-list-call-history collapsible-card ${callHistorySectionExpanded ? 'expanded' : ''}`}>
          <div
            className="card-header collapsible-header"
            onClick={() => setCallHistorySectionExpanded(v => !v)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setCallHistorySectionExpanded(v => !v); } }}
          >
            <h3>
              <span className="collapsible-chevron" aria-hidden>{callHistorySectionExpanded ? '▼' : '▶'}</span>
              История обзвонов Junior ({callHistoryTotal})
            </h3>
            {callHistorySectionExpanded && (
              <div className="search-container" onClick={(e) => e.stopPropagation()}>
                <input
                  type="text"
                  className="search-input"
                  placeholder="Поиск по нику..."
                  value={callHistorySearch}
                  onChange={(e) => {
                    setCallHistorySearch(e.target.value);
                    setCallHistoryPage(1);
                  }}
                />
              </div>
            )}
          </div>
          {callHistorySectionExpanded && (
          <>
          {callHistoryLoading ? (
            <div className="loading">Загрузка...</div>
          ) : callHistory.length === 0 ? (
            <div className="empty-state">
              {callHistorySearch ? 'Записи по запросу не найдены' : 'История обзвонов пуста'}
            </div>
          ) : (
            <>
              <div className="moderator-table-container">
                <table className="moderator-table call-history-table">
                  <thead>
                    <tr>
                      <th>Кому проводили обзвон</th>
                      <th>Кто проводил</th>
                      <th>Дата добавления менеджера</th>
                      <th>Дата проведения обзвона</th>
                      <th>Баллы</th>
                    </tr>
                  </thead>
                  <tbody>
                    {callHistory.map((row) => (
                      <tr key={row.id}>
                        <td>{row.junior_nickname || '—'}</td>
                        <td>{row.conductor_nickname || '—'}</td>
                        <td>
                          {row.moderator_created_at
                            ? new Date(row.moderator_created_at).toLocaleDateString('ru-RU', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit'
                              })
                            : '—'}
                        </td>
                        <td>
                          {row.call_date
                            ? new Date(row.call_date).toLocaleString('ru-RU', {
                                year: 'numeric',
                                month: '2-digit',
                                day: '2-digit',
                                hour: '2-digit',
                                minute: '2-digit'
                              })
                            : '—'}
                        </td>
                        <td className="call-history-score">{row.score != null ? Number(row.score) : '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {!callHistoryLoading && callHistory.length > 0 && callHistoryTotalPages > 1 && (
                <div className="pagination">
                  <button
                    className="pagination-btn"
                    onClick={() => setCallHistoryPage(prev => Math.max(1, prev - 1))}
                    disabled={callHistoryPage === 1}
                  >
                    Назад
                  </button>
                  <span className="pagination-info">
                    Страница{' '}
                    <input
                      type="number"
                      className="pagination-input"
                      min={1}
                      max={callHistoryTotalPages}
                      value={callHistoryPage}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (v === '') return;
                        const n = parseInt(v, 10);
                        if (!isNaN(n)) setCallHistoryPage(Math.max(1, Math.min(callHistoryTotalPages, n)));
                      }}
                      aria-label="Номер страницы"
                    />
                    {' '}из {callHistoryTotalPages}
                  </span>
                  <button
                    className="pagination-btn"
                    onClick={() => setCallHistoryPage(prev => Math.min(callHistoryTotalPages, prev + 1))}
                    disabled={callHistoryPage === callHistoryTotalPages}
                  >
                    Вперёд
                  </button>
                </div>
              )}
            </>
          )}
          </>
          )}
        </div>

        {canReviewDataChanges() && (
        <div className={`moderator-list-card collapsible-card ${dataChangeSectionExpanded ? 'expanded' : ''}`}>
          <div
            className="card-header collapsible-header"
            onClick={() => {
              const next = !dataChangeSectionExpanded;
              setDataChangeSectionExpanded(next);
              if (next) fetchDataChangeRequests();
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const next = !dataChangeSectionExpanded;
                setDataChangeSectionExpanded(next);
                if (next) fetchDataChangeRequests();
              }
            }}
          >
            <h3>
              <span className="collapsible-chevron" aria-hidden>{dataChangeSectionExpanded ? '▼' : '▶'}</span>
              Заявки на смену данных
              {dataChangePendingCount > 0 && (
                <span className="vacations-requests-count-badge" style={{ marginLeft: 8 }}>
                  {dataChangePendingCount}
                </span>
              )}
            </h3>
            {dataChangeSectionExpanded && (
              <div className="moder-log-header-actions" onClick={(e) => e.stopPropagation()}>
                <button
                  type="button"
                  className={`vacations-toggle-requests-btn ${dataChangeStatusFilter === 'pending' ? 'active' : ''}`}
                  onClick={() => setDataChangeStatusFilter('pending')}
                >
                  Ожидают
                </button>
                <button
                  type="button"
                  className={`vacations-toggle-requests-btn ${dataChangeStatusFilter === 'all' ? 'active' : ''}`}
                  onClick={() => setDataChangeStatusFilter('all')}
                >
                  История
                </button>
              </div>
            )}
          </div>
          {dataChangeSectionExpanded && (
            <>
              {dataChangeLoading ? (
                <div className="loading">Загрузка...</div>
              ) : dataChangeItems.length === 0 ? (
                <div className="empty-state">
                  {dataChangeStatusFilter === 'pending'
                    ? 'Нет заявок на рассмотрении'
                    : 'История заявок пуста'}
                </div>
              ) : (
                <div className="vacations-requests-container" style={{ padding: '0 16px 16px' }}>
                  <div className="vacations-requests-grid">
                    {dataChangeItems.map((req) => (
                      <div key={req.id} className="vacations-request-card">
                        <div className="vacations-request-card-header">
                          <div className="vacations-request-card-moderator">
                            <div className="vacations-request-card-avatar">
                              {req.moderatorNickname?.charAt(0).toUpperCase() || '?'}
                            </div>
                            <div className="vacations-request-card-moderator-info">
                              <div className="vacations-request-card-name">{req.moderatorNickname}</div>
                              {req.moderatorServer && (
                                <div className="vacations-request-card-server">{req.moderatorServer}</div>
                              )}
                            </div>
                          </div>
                          <div className="vacations-request-card-date">
                            {new Date(req.createdAt).toLocaleString('ru-RU', {
                              day: '2-digit',
                              month: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </div>
                        </div>
                        <div className="vacations-request-card-section">
                          <div className="vacations-request-card-label">Изменение</div>
                          <div className="vacations-request-card-reason">{req.fieldLabel}</div>
                        </div>
                        <div className="vacations-request-card-section">
                          <div className="vacations-request-card-label">Было → Станет</div>
                          <div className="vacations-request-card-reason">
                            {req.oldDisplay || req.oldValue || '—'} → {req.newDisplay || req.newValue}
                          </div>
                        </div>
                        <div className="vacations-request-card-section">
                          <div className="vacations-request-card-label">Причина менеджера</div>
                          <div className="vacations-request-card-reason">{req.reason}</div>
                        </div>
                        {req.status !== 'pending' && (
                          <div className="vacations-request-card-section">
                            <div className="vacations-request-card-label">
                              {req.status === 'approved' ? 'Одобрено' : 'Отклонено'}
                              {req.reviewedByName ? ` (${req.reviewedByName})` : ''}
                            </div>
                            {req.rejectionReason && (
                              <div className="vacations-request-card-reason">{req.rejectionReason}</div>
                            )}
                          </div>
                        )}
                        {req.status === 'pending' && (
                          <div className="vacations-request-card-actions">
                            <button
                              type="button"
                              className="vacations-request-card-approve"
                              onClick={() => handleApproveDataChange(req.id)}
                            >
                              Одобрить
                            </button>
                            <button
                              type="button"
                              className="vacations-request-card-reject"
                              onClick={() => setDataChangeRejectModal({ isOpen: true, requestId: req.id })}
                            >
                              Отклонить
                            </button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        )}

        {/* Логи снятых менеджеров (свёрнуто по умолчанию) */}
        <div ref={moderLogSectionRef} className={`moderator-list-card moderator-list-logs collapsible-card ${moderLogSectionExpanded ? 'expanded' : ''}`}>
          <div
            className="card-header collapsible-header"
            onClick={() => {
              const next = !moderLogSectionExpanded;
              setModerLogSectionExpanded(next);
              if (next) fetchModerLogs();
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const next = !moderLogSectionExpanded;
                setModerLogSectionExpanded(next);
                if (next) fetchModerLogs();
              }
            }}
          >
            <h3>
              <span className="collapsible-chevron" aria-hidden>{moderLogSectionExpanded ? '▼' : '▶'}</span>
              Логи снятых менеджеров ({moderLogTotal})
            </h3>
            {moderLogSectionExpanded && (
              <div className="moder-log-header-actions" onClick={(e) => e.stopPropagation()}>
                <a
                  className="moder-log-export-link"
                  href="/discordmoderation/settings?tab=data-export"
                  onClick={(e) => e.stopPropagation()}
                  style={{ fontSize: 13, opacity: 0.8, marginRight: 8 }}
                >
                  Настройки → Выгрузки
                </a>
                {canAddModerLog() && (
                  <button
                    type="button"
                    className="btn btn-add-moderator btn-add-log"
                    onClick={() => openModerLogForm()}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
                    </svg>
                    Добавить запись
                  </button>
                )}
                {canImportModerLogs() && (
                  <>
                    <input
                      type="file"
                      ref={moderLogFileInputRef}
                      accept=".csv"
                      onChange={handleModerLogFileSelect}
                      style={{ display: 'none' }}
                    />
                    <button
                      type="button"
                      className="btn btn-secondary btn-import-logs"
                      onClick={() => moderLogFileInputRef.current?.click()}
                      disabled={moderLogImporting}
                    >
                      {moderLogImporting ? 'Импорт...' : 'Импорт из CSV'}
                    </button>
                  </>
                )}
                <input
                  type="text"
                  className="search-input"
                  placeholder="Поиск..."
                  value={moderLogSearch}
                  onChange={(e) => {
                    setModerLogSearch(e.target.value);
                    setModerLogPage(1);
                  }}
                />
              </div>
            )}
          </div>
          {moderLogSectionExpanded && (
          <>
          {moderLogLoading ? (
            <div className="loading">Загрузка...</div>
          ) : moderLogData.length === 0 ? (
            <div className="empty-state">
              {moderLogSearch ? 'Записи по запросу не найдены' : 'Нет записей. Добавьте первую или импортируйте из CSV.'}
            </div>
          ) : (
            <>
              <div className="moderator-table-container">
                <table className="moderator-table moder-log-table">
                  <thead>
                    <tr>
                      <th>Никнейм менеджера</th>
                      <th>Discord ID</th>
                      <th>Когда встал — когда ушёл</th>
                      <th>Причина</th>
                      <th>Комментарий</th>
                      {(canEditModerLog() || canDeleteModerLog()) && <th className="actions-column">Действия</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {moderLogData.map((row) => (
                      <tr key={row.id}>
                        <td>{row.nickname || '—'}</td>
                        <td className="moder-log-discord">{row.discordId || '—'}</td>
                        <td>{row.period || '—'}</td>
                        <td>{row.reason || '—'}</td>
                        <td className="moder-log-comment">{row.comment || '—'}</td>
                        {(canEditModerLog() || canDeleteModerLog()) && (
                          <td className="actions-column">
                            <div className="action-buttons">
                              {canEditModerLog() && (
                                <button
                                  type="button"
                                  className="btn-action btn-edit"
                                  onClick={() => openModerLogForm(row)}
                                  title="Изменить"
                                >
                                  Изменить
                                </button>
                              )}
                              {canDeleteModerLog() && (
                                <button
                                  type="button"
                                  className="btn-action btn-delete"
                                  onClick={() => handleDeleteModerLog(row)}
                                  title="Удалить"
                                >
                                  Удалить
                                </button>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {moderLogTotalPages > 1 && (
                <div className="pagination">
                  <button
                    className="pagination-btn"
                    onClick={() => setModerLogPage((p) => Math.max(1, p - 1))}
                    disabled={moderLogPage === 1}
                  >
                    Назад
                  </button>
                  <span className="pagination-info">
                    Страница{' '}
                    <input
                      type="number"
                      className="pagination-input"
                      min={1}
                      max={moderLogTotalPages}
                      value={moderLogPage}
                      onChange={(e) => {
                        const v = e.target.value;
                        if (v === '') return;
                        const n = parseInt(v, 10);
                        if (!isNaN(n)) setModerLogPage(Math.max(1, Math.min(moderLogTotalPages, n)));
                      }}
                      aria-label="Номер страницы"
                    />
                    {' '}из {moderLogTotalPages}
                  </span>
                  <button
                    className="pagination-btn"
                    onClick={() => setModerLogPage((p) => Math.min(moderLogTotalPages, p + 1))}
                    disabled={moderLogPage === moderLogTotalPages}
                  >
                    Вперёд
                  </button>
                </div>
              )}
            </>
          )}
          </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManagerManagement;

